import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import * as actions from '../../actions/index';
import vuepay_large_logo from '../../assets/images/vuepaylogonav@5x.png';
import loading_white from '../../assets/gif/loading_white.gif';
import { Link } from 'react-router-dom';
import { checkIfForgotPassword, renderField } from "../../util/account_management";
import { LOGIN, setData } from "../../util/storage";
import { vuepayAlert } from "../../util/utility";

import { get as _get } from "lodash";

import ModelTemp from "../../components/modal/ModelTemp";

class ForgotPassword extends Component {

    required = value => (value ? undefined : 'Required')

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(values) {

        const data = {
            email: values.email,
            device: this.props.device
        };
        this.props.forgotPassword(data);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (checkIfForgotPassword(nextProps)) {
            //if the status_code received from the server is 200 means the user has successfully done the forgot password
            if (nextProps.account_management.forgotPassword.status_code === 200) {
                vuepayAlert("success", nextProps.account_management.forgotPassword.message, () => {
                    setData(LOGIN, nextProps.account_management.forgotPassword.data, () => {
                        nextProps.history.push("/dashboard/login");
                        nextProps.resetPassword();
                    });
                });
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                vuepayAlert("error", nextProps.account_management.forgotPassword.message, () => {
                    nextProps.resetPassword();
                });
            }
        }

    }

    render() {

        const { handleSubmit, location } = this.props;
        const basePath = _get(location, 'state.basePath', '')
        //console.log("inside forgotpassword:::::::::", location);

        return (
            <ModelTemp>
                <div>
                    <main role="main" className="">
                        <div className="login-container">
                            <div className="popup-header">
                                <button type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => {
                                        document.getElementsByClassName("modal-overlay")[0].style.display = "none";
                                        // this.props.history.push(basePath)
                                        this.props.history.push(
                                            {
                                                pathname: this.props.location.state.parentPath ? this.props.location.state.parentPath.basePath : this.props.location.state.basePath,
                                                search: this.props.location.state.parentPath ? this.props.location.state.parentPath.search : this.props.location.state.search,
                                                state: {
                                                    basePath: this.props.location.state.parentPath ? this.props.location.state.parentPath.basePath : this.props.location.state.basePath,
                                                    search: this.props.location.state.parentPath ? this.props.location.state.parentPath.search : this.props.location.state.search,
                                                }
                                            }
                                        );
                                    }
                                    }
                                >
                                    <img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                                </button>

                            </div>
                            <div className="row">
                                <div className="col-md-6 bg-primary d-flex align-items-center text-center" style={{ borderRight: '1px solid #e7e7e7' }}>
                                    <img src={vuepay_large_logo} alt={"VuePay"} className="img-fluid" />
                                </div>
                                <div className="col-md-6 bg-white d-flex align-items-center">
                                    <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        <h4>Forgot your password</h4>
                                        <p className="mb-4">Enter your email below to receive your password reset
                                        instructions </p>
                                        <Field
                                            label="Email"
                                            name="email"
                                            type="email"
                                            height={"47px"}
                                            email={true}
                                            username={null}
                                            validate={[this.required]}
                                            component={renderField}
                                        />
                                        <div className="mt-4 text-center">
                                            <button className="btn btn-primary">
                                                {
                                                    this.props.account_management.isFetching
                                                        ?
                                                        <img src={loading_white} alt={"Loading"} width={26} height={26} />
                                                        :
                                                        'Reset password'
                                                }
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className="back-btn">
                                    <Link

                                        to={{
                                            pathname: '/login',

                                            state: {
                                                "basePath": basePath,
                                                "parentPath": {
                                                    basePath: this.props.location.state.parentPath ? this.props.location.state.parentPath.basePath : this.props.location.state.basePath,
                                                    search: this.props.location.state.parentPath ? this.props.location.state.parentPath.search : this.props.location.state.search,
                                                }
                                            }
                                        }}
                                        title="Back"></Link>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </ModelTemp>
        );
    }
}

function mapStateToProps(state) {

    return {
        account_management: state.account_management,
        device: state.device.payload
    };
}

export default reduxForm({
    form: 'ForgotPasswordForm'
})(
    connect(mapStateToProps, actions)(ForgotPassword)
);